// src/app/slices/openingSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IOpening, IOpeningParams, AccessoryState } from '../models';

const initialState: AccessoryState<IOpening, IOpeningParams> = {
  accessories: {},
  params: null,
};

const openingSlice = createSlice({
  name: 'opening',
  initialState,
  reducers: {
    setOpening: (state, action: PayloadAction<IOpening>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setOpeningParams: (state, action: PayloadAction<IOpeningParams>) => {
      state.params = action.payload;
    },
    deleteOpening: deleteAccessory,
  },
});

export const { setOpening, setOpeningParams, deleteOpening } =
  openingSlice.actions;

export default openingSlice.reducer;
